import { BaseRouteService } from 'core/services';

class DocumentationRequestRouteService extends BaseRouteService {
    constructor() {
        super('documentation-request');
    }

    download() {
        return super.find(this.base + '/download');    
    }

    getEmailPrefillData(id) {
        return super.get(this.base + '/get-email-prefill-data/{id}', id);
    }

    getNikoEmailPrefillData(id) {
        return super.get(this.base + '/get-niko-email-prefill-data/{id}', id);
    }

    sendEmail(resource) {
        return super.create(`${this.base}/send-email`, resource, {
            'content-type': 'multipart/form-data',
        });
    }
    
    checkMissingDocuments(resource) {
        return super.get(`${this.base}/check-missing-documents/{facilityOrderId}`, null, resource);	
    }
    
    checkNikoMissingDocuments(resource) {
        return super.get(`${this.base}/check-niko-missing-documents/{facilityOrderId}`, null, resource);
    }

    hasPreviousDosTemplates(resource) {
        return super.get(`${this.base}/has-previous-dos-templates/{facilityOrderId}`, null, resource);
    }
}

export default DocumentationRequestRouteService;
